import MBBSAbroadPage from "../../ug_abroad/MBBSAbroadPage";

export default function MBBSAbroad() {
  return <MBBSAbroadPage />;
}